import {
    isIOS,
    isMacOs
} from "react-device-detect";
import { PHOTO_SHERLOCK_APP_STORE_LINK, PHOTO_SHERLOCK_GOOGLE_PLAY_LINK } from "../view/StoresButton/StoresButtons";

export default class NavigationManager {
    static privacyPolicyUrl = 'https://photo-sherlock.s3.eu-central-1.amazonaws.com/privacy_policy.html';
    static imageSearchHost = 'https://photosherlock.com';

    static openUrlInNewTab(url) {
        window.open(url, '_blank');
    }

    static openImageSearchUrl(imageUrl) {
        let url = new URL(this.imageSearchHost)
        url.searchParams.set(UrlParameter.imageUrl, imageUrl)
        this.openUrlInNewTab(url)
    }

    static getAppStoreLink() {
        return isIOS || isMacOs ? PHOTO_SHERLOCK_APP_STORE_LINK : PHOTO_SHERLOCK_GOOGLE_PLAY_LINK;
    }
}

export class UrlParameter {
    static imageUrl = "image_url";
    static searchResults = "search_results";
}